
export const baseUrl = /debug/.test(window.location.search)
         ? "super-wallpaper/textures"
         : "https://p.ubug.io/super-wallpaper/textures";

export function setFont() {
  const styleEl = document.createElement("style");
  styleEl.innerHTML = `
  @font-face {
    font-family: mipro;
    src: url(${baseUrl}/mipro.cutted.ttf)
  }
  body{
    font-family: mipro;
  }
  `;
  document.body.appendChild(styleEl);
}
